import store from "@/store";
import storageObservable from './storageObservable';

window.addEventListener('online', (event) => {
    store.dispatch('setNetworkState', 'online')
});
window.addEventListener('offline', (event) => {
    store.dispatch('setNetworkState', 'offline')
});

storageObservable.subscribe<{ status: boolean, user: string }[]>('offlineMode', (data) => {
    let findData = data.find((el) => el.user === store.getters.profile.email)
    if (findData) store.commit('setOfflineMode', findData.status)
})

storageObservable.subscribe<{ status: boolean, user: string }[]>('autoDownload', (data) => {
    let findData = data.find((el) => el.user === store.getters.profile.email)
    if (findData) store.commit('setAutoDownload', findData.status)
})